import { Value } from './data-reference';

export enum OPERATORS {
  AND = 'and',
  OR = 'or',
  NOT = 'not',
  EQ = '=',
  LT = '<',
  GT = '>',
  SUM = '+',
  MINUS = '-',
  PRODUCT = '*',
  DIVIDE = '/',
  IF = '?',
  REGEXP = 're', // regular expression match test
  IN = 'in', // Array includes test
  INTERSECT = 'intersect', // Intersection of arrays not empty
  PATH = 'path',
  TRACE = 'trace',
  TRACE_EVAL = 'traceEval',
}

export type Bindings = { [key: string]: ConditionalExpression };

export type Let = {
  bindings: Bindings;
  body: ConditionalExpression;
};

export type EvaluateableExpression = [OPERATORS, ...ConditionalExpression[]];

export type ConditionalExpression = Let | EvaluateableExpression | Value;
